import { useEffect, useState } from "react";

const navLinks = [
  { id: "top", label: "首页" },
  { id: "rank", label: "热搜榜" },
  { id: "category", label: "主题分区" },
  { id: "feed", label: "爆料流" },
  { id: "hotread", label: "热评精选" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-[#fbf7ef]/90 backdrop-blur-md border-b border-amber-900/10"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 md:h-[72px] items-center justify-between">
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
            <span className="grid w-9 h-9 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-500 text-white items-center justify-center font-display text-lg shadow-[0_4px_12px_rgba(16,185,129,0.35)]">
              瓜
            </span>
            <span className="font-display text-2xl text-[#201d1a] tracking-wide">
              爆瓜<span className="text-emerald-600">网</span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className="px-3 py-2 rounded-lg text-[15px] text-[#201d1a]/80 hover:text-emerald-700 hover:bg-emerald-600/10 transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#submit"
              className="hidden sm:inline-flex items-center gap-2 rounded-lg bg-[#ff4d3d] px-5 py-2.5 text-[15px] font-semibold text-white hover:bg-[#e63e30] transition-colors whitespace-nowrap"
            >
              <i className="ri-upload-cloud-2-line w-5 h-5 flex items-center justify-center"></i>
              立即投稿
            </a>
            <button
              onClick={() => setOpen((v) => !v)}
              aria-label="打开菜单"
              className="md:hidden grid w-10 h-10 place-items-center rounded-lg text-[#201d1a] hover:bg-amber-900/10"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} w-6 h-6 flex items-center justify-center text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#fbf7ef]/95 backdrop-blur border-t border-amber-900/10 px-4 pb-4 pt-2">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={() => setOpen(false)}
              className="block px-3 py-3 rounded-lg text-[#201d1a] hover:bg-emerald-600/10"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#submit"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-2 rounded-lg bg-[#ff4d3d] px-5 py-3 font-semibold text-white whitespace-nowrap"
          >
            <i className="ri-upload-cloud-2-line w-5 h-5 flex items-center justify-center"></i>
            立即投稿
          </a>
        </div>
      )}
    </header>
  );
}